
export const bookingHistory = [
  {
    id: 'VE-2025-4821',
    date: '2025-01-18',
    departure: 'Aéroport de Genève (GVA)',
    destination: 'Courchevel 1850',
    vehicle: 'Mercedes Classe E',
    passengers: 2,
    bagages: 3,
    price: 358.74,
    distance: 180,
    status: 'completed',
    chauffeur: 'Alexandre M.',
    heure: '14:30',
    rating: 5,
  },
  {
    id: 'VE-2025-5102',
    date: '2025-01-25',
    departure: 'Gare de Moûtiers',
    destination: 'Méribel',
    vehicle: 'Mercedes Van',
    passengers: 5,
    bagages: 6,
    price: 125.00,
    distance: 22,
    status: 'completed',
    chauffeur: 'Thomas R.',
    heure: '10:00',
    rating: 5,
  },
  {
    id: 'VE-2025-5387',
    date: '2025-02-08',
    departure: 'Aéroport Lyon Saint-Exupéry (LYS)',
    destination: 'Val Thorens',
    vehicle: 'Mercedes Classe E',
    passengers: 2,
    bagages: 4,
    price: 518.59,
    distance: 190,
    status: 'completed',
    chauffeur: 'Alexandre M.',
    heure: '16:45',
    rating: 4,
  },
  {
    id: 'VE-2025-5690',
    date: '2025-02-22',
    departure: 'Aéroport de Chambéry (CMF)',
    destination: 'Les Arcs 1950',
    vehicle: 'Mercedes Van',
    passengers: 6,
    bagages: 8,
    price: 474.30,
    distance: 120,
    status: 'completed',
    chauffeur: 'Thomas R.',
    heure: '09:15',
    rating: 5,
  },
  {
    id: 'VE-2025-6012',
    date: '2025-03-15',
    departure: 'Aéroport de Genève (GVA)',
    destination: 'Chamonix',
    vehicle: 'Mercedes Classe E',
    passengers: 2,
    bagages: 2,
    price: 250.64,
    distance: 88,
    status: 'upcoming',
    chauffeur: 'À assigner',
    heure: '11:00',
    rating: 0,
  },
  {
    id: 'VE-2025-6234',
    date: '2025-03-22',
    departure: 'Aéroport Lyon Saint-Exupéry (LYS)',
    destination: 'Tignes',
    vehicle: 'Mercedes Van',
    passengers: 4,
    bagages: 5,
    price: 676.99,
    distance: 230,
    status: 'upcoming',
    chauffeur: 'À assigner',
    heure: '08:30',
    rating: 0,
  },
  {
    id: 'VE-2024-3201',
    date: '2024-12-20',
    departure: 'Aéroport de Genève (GVA)',
    destination: 'Megève',
    vehicle: 'Mercedes Classe E',
    passengers: 2,
    bagages: 3,
    price: 264.50,
    distance: 72,
    status: 'completed',
    chauffeur: 'Alexandre M.',
    heure: '17:00',
    rating: 5,
  },
  {
    id: 'VE-2024-2890',
    date: '2024-11-15',
    departure: 'Aéroport de Chambéry (CMF)',
    destination: 'Val d\'Isère',
    vehicle: 'Mercedes Classe E',
    passengers: 3,
    bagages: 4,
    price: 393.24,
    distance: 130,
    status: 'cancelled',
    chauffeur: '-',
    heure: '13:00',
    rating: 0,
  },
];

export const customerProfile = {
  name: 'Philippe Durand',
  email: 'philippe.durand@email.com',
  phone: '+33 6 12 34 56 78',
  memberSince: '2024-06-15',
  totalTrips: 6,
  totalSpent: 1891.67,
  favoriteDestination: 'Courchevel',
  status: 'Premium',
};
